// v-bump plk-slip r3 2026-10-24: F1 keyboard-open (Enter/Space on the date fields) — engine js changed → fresh ?v= (cache law #74: both copies).
// v-bump plk-slip r2 2026-10-23: F2 cell-anchored sheet + F5 panel mutual exclusion -> fresh ?v= (cache law #74: both copies).
// v-bump plk-slip 2026-10-23: engine js changed (slip anatomy, months scroller, document Escape, is-above shadow) -> fresh ?v= (cache law #74: both copies).
// v-bump cal-ux-b5 2026-10-11: base showCalendar no longer scroll-jumps the page (scrollControlToTop rAFs removed) — engine js changed → ?v= re-bump (cache law #74).
// v-bump cal-ux-b 2026-10-11: calendar popup UX — desktop popover anchored below the
// dates field (clamped/flipped, never offscreen), mobile bottom sheet (≤80vh, months
// scroll inside), visible X close at both breakpoints, no page-scroll on open. Engine
// js+css changed → fresh CDN ?v= (cache law #74: the loader's own ?v= is mirrored onto
// the deferred rect build by this same file — see the __plkTravelSearchEngine block).
// plk-w7 2026-10-07 loader re-bump (engine js+css changed — fingerprint law doc 71 §32)
// v-bump v38-gtm-3c 2026-10-06: grouped-header property hero video (IO-gated) + fallback byte-equal — fresh CDN ?v= (cache law #74)
// v-bump v37-plk-sr2 2026-09-10: card CTA pair + rail one-flow + engine canonical — fresh CDN ?v= (cache law #74)
// v-bump v36-anon-terms 2026-09-10: content bump so the CDN mints a fresh ?v= (cache law #74)
// prior: 2026-09-10c CSS comment nested-star fix (minify blocker) + promo 20px inset
// Tiny loader to defer-load the full Travel Search script without tripping theme check size limits.
(function() {
  try {
    // T20-S4 (chain pages): a page may carry MULTIPLE widget sections (engadin = 2).
    // Without this guard each section's loader tag appends the engine again — the second
    // eval hits 'Identifier TravelSearchComponent already declared' and kills ALL init.
    // PDP pages have exactly one section: behaviour unchanged (flag set once).
    if (window.__plkTravelSearchEngine) return;
    window.__plkTravelSearchEngine = true;
    var current = document.currentScript;
    var base = '';
    var version = '';
    if (current && current.src) {
      var parts = current.src.split('/');
      parts.pop(); // remove file name
      base = parts.join('/');
      // T19-H-5b: mirror this loader's OWN ?v= onto the deferred build. The loader tag's
      // ?v= is emitted by Liquid asset_url from the loader asset's updated_at, so it changes
      // each time the loader is re-uploaded — while the rect asset's ?v= here is a fixed
      // CDN cache key per URL (Shopify CDN caches per full URL incl. query). The old
      // hardcoded '?v=401' froze the rect JS at its first-uploaded build, which is why the
      // H-2c serializer fix was never actually served live.
      var m = current.src.match(/[?&]v=([^&]+)/);
      if (m) version = '?v=' + m[1];
    }
    // Default to the rectangular v1 build
    var mainPath = (base ? base + '/' : '') + 'travel-search-rectangular-v1.js';
    var s = document.createElement('script');
    s.src = mainPath + version;
    s.defer = true;
    document.head.appendChild(s);
  } catch (e) {
    // no-op
  }
})();

// TS-2 (2026-09-03): rect rides this script src ?v= hash — comment bump re-versions the URL so the asset-CDN serves the updated rectangular-v1.js (gotcha #63).

// TS-3 (2026-09-03): variant_id ride + pending_data amendment — loader bump (gotcha #74: BOTH copies) forces ?v= re-version.

// TS-11 (2026-09-04): URL-dates auto-search + promo collapsed disclosure (chip) — loader bump forces ?v= re-version (gotcha #74).

// TS-12 (2026-10-02): hp-clarity G-F — nightly basis line moved into the config parenthetical (plk-sr2 C4 holds); loader bump forces ?v= re-version (gotcha #74: BOTH copies).

// TS-13 (2026-10-02): G-F follow-up — async price-update path overwrote the config span and wiped the basis suffix; now mirrored there. Loader bump (gotcha #74: BOTH copies).

// DEMO-TS-UI (2026-09-05): promo zone moved into results; 50-50 room card; all
// amenities spelled out; thumbnail strip removed; PDP-mode header suppression —
// loader bump forces ?v= re-version (gotchas #63/#74).

// demo-v3 A1 (2026-09-10): hover-follow nights tooltip — V30 method-copy list
// gains plkPrefersFineHover/plkPositionRangeTooltip; loader re-bump so the rect
// asset re-versions under a fresh ?v (gotcha #74: BOTH copies, every push).

// plk-sr3 (2026-09-10): invoice ratePlanId fix + card title left-align — loader re-bump so rect js+css re-version (gotchas #63/#74).

// plk-sr4 (2026-09-11): invoice button loading-dots — loader re-bump

// plk-sr4b: restore clean

// plk-w6 (2026-10-07): W5 label fix — loader re-bump so rect js re-versions (gotchas #63/#74, doc 71 s32)

// r7 (2026-10-17): new-tab property results (travel-search-rectangular-v1.js) — loader re-bump so the rect asset re-versions under a fresh ?v (gotchas #63/#74: BOTH copies).

// trs (2026-10-17): submit-target new-tab redirect — loader re-bump, both copies.
